import { client } from "../../../Infrastructure/agent";
export const MonthlyPerformanceService = {
  downloadTemplate: () =>
    client.getFile("/MonthlyProduction/DownloadProductionTemplate"),

  downloadparameterTemplate: () =>
    client.getFile("/MonthlyProduction/DownloadRateTemplate"),
  saveMonthlyProduction: (data, month, year, uploadedBy, reupload) =>
    client.post("/MonthlyProduction/SaveMonthlyproduction", {
      data,
      month,
      year,
      uploadedBy,
      reupload,
    }),
  loadProductionHistory: (query, view) =>
    client.post("/MonthlyProduction/LoadProductionHistory", {
      query,
      view,
    }),

  query: (criteria) =>
    client.post("/MonthlyProduction/RunQuery", {
      criteria,
    }),
  saveQuery: (query) =>
    client.post("/MonthlyProduction/SaveQuery", {
      query,
    }),
  loadSavedQuery: (start, end) =>
    client.post("/MonthlyProduction/LoadSavedQuery", {
      start,
      end,
    }),
  loadSavedQueryByName: (fullName) =>
    client.post("/MonthlyProduction/LoadSavedQueryByName", {
      fullName,
    }),
  deleteQuery: (query) =>
    client.post("/MonthlyProduction/DeleteQuery", {
      query,
    }),

  lockProduction: (lockdate, islocked, lockedby) =>
    client.post("/MonthlyProduction/LockProduction", {
      lockdate,
      islocked,
      lockedby,
    }),
  deleteProduction: (lockdate, lockedby) =>
    client.post("/MonthlyProduction/DeleteProduction", {
      lockdate,

      lockedby,
    }),

  loadUploadStatus: () => client.get("/MonthlyProduction/loadUploadStatus"),
};

